<div class="optimize mt-5">
  <div class="section-title text-center">
    {{ "Optimize Your LinkedIn Profile" | translate }}
  </div>

  <div class="row w-100 mt-3 mx-0 justify-content-center mt-5">
    <div class="col-12 col-md-7 my-auto px-5 order-md-1 order-2">
      <div class="description-title">
        {{ "What’s your profile score" | translate }}
      </div>
      <div class="description">
        {{ "Up Career evaluates your LinkedIn" | translate }}
      </div>

      <button class="gradient-button" routerLink="/scan-linkedin">
        {{ "Scan Your Profile" | translate }}
      </button>
      <button class="border-button" routerLink="/create-linkedin-profile">
        {{ "Create LinkedIn Profile" | translate }}
      </button>
    </div>
    <img
      class="col-8 col-md-5 text-center p-0 order-md-2 order-1"
      src="../../../assets/img/optimize-linkedIn.png"
    />
  </div>
</div>
